













































import { useStatusBoardCharacterModule } from '@/modules/statusBoard/character';
import { CharacterParameter, CharacterPart } from '@/types/statusBoard';
import { defineComponent, PropType, reactive, SetupContext, watch } from '@vue/composition-api';

export default defineComponent({

  props: {
    value: { type: Boolean as PropType<boolean>, required: true },
    part: { type: Object as PropType<CharacterPart>, required: true },
    select: { type: String as PropType<string>, required: false, default: '' }
  },

  setup (props, ctx: SetupContext) {

    const characterModule = useStatusBoardCharacterModule();

    function initParameter (): CharacterParameter {
      const parameter = props.part.parameters.find(p => p.name === props.select);
      if (!parameter) return { current: 0, max: 0, color: '', name: 'NO DATA' };
      return characterModule.copyParameter(parameter);
    }

    const localState = reactive({
      parameter: initParameter(),
      value: 0
    });

    watch(() => props.value, showDialog => {
      if (!showDialog) return;
      localState.parameter = initParameter()
      localState.value = 0;
    });

    function input (value: boolean): void {
      ctx.emit('input', value);
    }

    function done (): void {
      if (localState.parameter.name === 'NO DATA') return;
      input(false);
      localState.parameter.current += localState.value;
      ctx.emit('done', localState.parameter);
    }

    function add (value: number): void {
      if (localState.parameter.name === 'NO DATA') return;
      localState.value += value;
    }

    function sub (value: number): void {
      if (localState.parameter.name === 'NO DATA') return;
      localState.value -= value;
    }

    function reset (): void {
      if (localState.parameter.name === 'NO DATA') return;
      localState.value = localState.parameter.max - localState.parameter.current;
    }

    return {
      localState,
      input,
      done,
      add,
      sub,
      reset
    };
  }
});
